module.exports = __webpack_public_path__ + "static/img/modelLibrary.0b634bad.png";